import { Component } from '@angular/core';
import { TradeInSelectors } from '@app/sales/states/customer-product-trade-in/customer-product-trade-in.selectors';
import { FormSelectors } from '@app/sales/states/form/form.selectors';
import { select } from '@ngxs/store';

@Component({
  selector: 'app-trade-in-summary',
  templateUrl: './trade-in-summary.component.html',
  styleUrl: './trade-in-summary.component.scss',
  standalone: true,
})
export class TradeInSummaryComponent {
  gradingQuestions = select(TradeInSelectors.gradingQuestions);
  tradeInConditionForm = select(FormSelectors.tradeInConditionForm);

  constructor() {}

  getGradingQuestionAnswer(questionType: string): string {
    const answer = this.tradeInConditionForm()?.[questionType] ?? '';
    const gradingQuestion = this.gradingQuestions()?.find(question => question.questionType === questionType);
    return gradingQuestion?.answerAlternatives.find(alternative => alternative.answer === answer)?.displayValue ?? '–';
  }
}
